<!-- ====================== MODAL CONTAINER ====================== -->
<div class="modal-container" [ngClass]="{'minimized': minimise}">

  <!-- ====================== MODAL HEADER ====================== -->
  <div class="modal-header">
    <h3 class="modal-title">{{ title }}</h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         title="Minimize or restore dialog"
         aria-label="Minimize or restore dialog"
         role="button"
         tabindex="0"
         (click)="minimise = !minimise"
         (keydown.enter)="minimise = !minimise"
         (keydown.space)="minimise = !minimise; $event.preventDefault()"></i>
      <i class="fa fa-times"
         style="cursor: pointer;"
         title="Close dialog"
         aria-label="Close dialog"
         role="button"
         tabindex="0"
         (click)="onCancel()"
         (keydown.enter)="onCancel()"
         (keydown.space)="onCancel(); $event.preventDefault()"></i>
    </div>
  </div>

  <!-- Issue Description -->
  @if (issueDesc) {
<table cellspacing="1" cellpadding="1" style="width:100%">
    <tr style="height:50px;">
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%"></td>
      <td style="width:20%;vertical-align:middle;text-align:left"><b>Issue: {{ issueDesc }}</b></td>
    </tr>
  </table>
}

  <!-- ====================== MODAL BODY ====================== -->
  <div class="modal-body" [hidden]="minimise">
    <!-- Loader -->
    @if (showFormLoader) {
<div class="row formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
    </div>
}

    <!-- Content -->
    @if (!showFormLoader) {
<div class="row">
      <!-- Entity Details Table -->
      <table class="table table-bordered form-inline enityDetails">
        <tr>
          @for (item of entityList | keyvalue; track item.key) {
<td>
            <span>{{ item.key }}</span>
          </td>
}
        </tr>
        <tr>
          @for (item of entityList | keyvalue; track item.key) {
<td>
            <span>{{ item.value }}</span>
          </td>
}
        </tr>
      </table>

      <!-- Main Form Table -->
      <table class="table table-bordered form-inline I_Entry">
        <thead>
          <tr>
            <th colspan="3">{{ modalTitle }}</th>
          </tr>
        </thead>
        <tbody>
          <!-- Reserved line for 2022 (Line 29 -> shows as "Reserved for future use") -->
          @if (showReservedLine29()) {
<tr class="formDataBlock">
            <td class="line-number">29</td>
            <td class="descBlock">Reserved for future use</td>
            <td class="yes-no-cell">&nbsp;</td>
          </tr>
}

          @for (row of scheduleBFormView.rows; track $index; let i = $index) {

            @if (!shouldHideRowForYear(row)) {
<tr class="formDataBlock">
              <!-- Line Number -->
              <td class="line-number">{{ getDisplayLineNumber(row) }}</td>
              
              <!-- Description and Controls -->
              <td class="descBlock">
                <!-- Checkbox prefix for lines 1a-1f (mutual exclusive - only one can be checked) -->
                @if (is1aTo1fLine(row.num)) {
<span>
                  <input type="checkbox" 
                         [checked]="row.value === true || row.value === 'true'"
                         (click)="onCheckbox1aTo1fClick(i)">
                </span>
}
                
                <!-- Description text (hide special 10b, 10c, 10d for 2023/2024) -->
                @if (!is10bLine(row.num) && !is10cLine(row.num) && !is10dLine(row.num)) {
<span class="description">{{ row.description }}</span>
}
                
                <!-- Special description for 10b (2023/2024) -->
                @if (is10bLine(row.num)) {
<span class="description">
                  <span>For this tax year, did the partnership make an optional basis adjustment under section 743(b)? If "Yes," enter the total aggregate net positive amount </span>
                  <input type="text" class="form-control input-sm inline-input" 
                         [(ngModel)]="row.value_user_input" 
                         [disabled]="row.conditionalField ?? false"
                         appOnlyDigits>
                  <span> and the total aggregate net negative amount</span>
                  <input type="text" class="form-control input-sm inline-input" 
                         [(ngModel)]="scheduleBFormView.rows[28].value_user_input2" 
                         [disabled]="scheduleBFormView.rows[28]?.conditionalField ?? false"
                         appOnlyDigits>
                  <span>of such section 743(b) adjustments for all partners made in the tax year. The partnership must also attach a statement showing the computation and allocation of each basis adjustment. See instructions.</span>
                </span>
}

                <!-- Special description for 10c (2023/2024) -->
                @if (is10cLine(row.num)) {
<span class="description">
                  <span>For this tax year, did the partnership make an optional basis adjustment under section 734(b)? If "Yes," enter the total aggregate net positive amount </span>
                  <input type="text" class="form-control input-sm inline-input" 
                         [(ngModel)]="scheduleBFormView.rows[29].value_user_input" 
                         [disabled]="scheduleBFormView.rows[29]?.conditionalField ?? false"
                         appOnlyDigits>
                  <span> and the total aggregate net negative amount </span>
                  <input type="text" class="form-control input-sm inline-input" 
                         [(ngModel)]="scheduleBFormView.rows[29].value_user_input2" 
                         [disabled]="scheduleBFormView.rows[29]?.conditionalField ?? false"
                         appOnlyDigits>
                  <span>of such section 734(b) adjustments for all partnership property made in the tax year. The partnership must also attach a statement showing the computation and allocation of each basis adjustment. See instructions.</span>
                </span>
}

                <!-- Special description for 10d (2023/2024) -->
                @if (is10dLine(row.num)) {
<span class="description">
                  <span>For this tax year, is the partnership required to adjust the basis of partnership property under section 743(b) or 734(b) because of a substantial built-in loss (as defined under section 743(d)) or substantial basis reduction (as defined under section 734(d))? If "Yes," enter the total aggregate amount of such section 743(b) adjustments and/or section 734(b) adjustments for all partners and/or partnership property made in the tax year.</span>
                  <input type="text" class="form-control input-sm inline-input" 
                         [(ngModel)]="row.value_user_input" 
                         [disabled]="row.conditionalField ?? false"
                         appOnlyDigits>
                  <span> The partnership must also attach a statement showing the computation and allocation of the basis adjustment. See instructions.</span>
                </span>
}
                
                <!-- Checkbox suffix for line 11 and 32 -->
                @if (row.num === '11' || row.num === '32') {
<span>
                  <input type="checkbox" 
                         [(ngModel)]="row.value" 
                         (click)="fieldVisibility(i, row.value)">
                </span>
}

                <!-- Sub-table for 2a (Entities) -->
                @if (row.num === '2a' && scheduleBFormView.rows[8]?.value === true) {
<div class="sub-table-container">
                  <table class="subTable">
                    <thead>
                      <tr>
                        <th>(i) Name of Entity</th>
                        <th>(ii) Employer Identification Number (if any)</th>
                        <th>(iii) Type of Entity</th>
                        <th>(iv) Country of Organization</th>
                        <th>(v) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                        <th class="addRowsColumn">
                          <i class="fa fa-plus-circle color-green" (click)="addRow('entity', 8)"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (values of row.JSON_DATA; track $index; let j = $index) {
<tr class="subtableRowHeight">
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_A" maxlength="75"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_B" maxlength="10"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_C" maxlength="1000"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_D[0]">
                            @for (country of allCountries; track $index) {
<option [ngValue]="country">{{ country.label }}</option>
}
                          </select>
                        </td>
                        <td><input type="text" class="form-control input-sm" #attribE2a="ngModel" [(ngModel)]="values.DATA_ATTRIB_E" onlyDigitsDecimal (ngModelChange)="limitDecimal(values.DATA_ATTRIB_E, '2a', j, 'DATA_ATTRIB_E', attribE2a)"></td>
                        <td class="addRowsColumn">
                          <i class="fa fa-minus-circle color-red" (click)="removeRow(8, j)"></i>
                        </td>
                      </tr>
}
                    </tbody>
                  </table>
                  @if (!row.JSON_DATA?.length) {
<div class="noRecordsBlock">
                    <span>No Records</span>
                  </div>
}
                </div>
}

                <!-- Sub-table for 2b (Individuals) -->
                @if (row.num === '2b' && scheduleBFormView.rows[10]?.value === true) {
<div class="sub-table-container">
                  <table class="subTable">
                    <thead>
                      <tr>
                        <th>(i) Name of Individual or Estate</th>
                        <th>(ii) Identifying Number (if any)</th>
                        <th>(iii) Country of Citizenship (see instructions)</th>
                        <th>(iv) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                        <th class="addRowsColumn">
                          <i class="fa fa-plus-circle color-green" (click)="addRow('individual', 10)"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (values of row.JSON_DATA; track $index; let j = $index) {
<tr class="subtableRowHeight">
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_A" maxlength="67"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_B" maxlength="10"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_C[0]">
                            @for (country of allCountries; track $index) {
<option [ngValue]="country">{{ country.label }}</option>
}
                          </select>
                        </td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_D" appOnlyDigits (ngModelChange)="limitDecimal(values.DATA_ATTRIB_D, '2b', j, 'DATA_ATTRIB_D')"></td>
                        <td class="addRowsColumn">
                          <i class="fa fa-minus-circle color-red" (click)="removeRow(10, j)"></i>
                        </td>
                      </tr>
}
                    </tbody>
                  </table>
                  @if (!row.JSON_DATA?.length) {
<div class="noRecordsBlock">
                    <span>No Records</span>
                  </div>
}
                </div>
}

                <!-- Sub-table for 3a (Corporations) -->
                @if (row.num === '3a' && scheduleBFormView.rows[13]?.value === true) {
<div class="sub-table-container">
                  <table class="subTable">
                    <thead>
                      <tr>
                        <th>(i) Name of Corporation</th>
                        <th>(ii) Employer Identification Number (if any)</th>
                        <th>(iii) Country of Incorporation</th>
                        <th>(iv) Percentage Owned in Voting Stock</th>
                        <th class="addRowsColumn">
                          <i class="fa fa-plus-circle color-green" (click)="addRow('corporation', 13)"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (values of row.JSON_DATA; track $index; let j = $index) {
<tr class="subtableRowHeight">
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_A" maxlength="67"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_B" maxlength="10"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_C[0]">
                            @for (country of allCountries; track $index) {
<option [ngValue]="country">{{ country.label }}</option>
}
                          </select>
                        </td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_D" appOnlyDigits (ngModelChange)="limitDecimal(values.DATA_ATTRIB_D, '3a', j, 'DATA_ATTRIB_D')"></td>
                        <td class="addRowsColumn">
                          <i class="fa fa-minus-circle color-red" (click)="removeRow(13, j)"></i>
                        </td>
                      </tr>
}
                    </tbody>
                  </table>
                  @if (!row.JSON_DATA?.length) {
<div class="noRecordsBlock">
                    <span>No Records</span>
                  </div>
}
                </div>
}

                <!-- Sub-table for 3b (Entities owned by partnership) -->
                @if (row.num === '3b' && scheduleBFormView.rows[15]?.value === true) {
<div class="sub-table-container">
                  <table class="subTable">
                    <thead>
                      <tr>
                        <th>(i) Name of Entity</th>
                        <th>(ii) Employer Identification Number (if any)</th>
                        <th>(iii) Type of Entity</th>
                        <th>(iv) Country of Organization</th>
                        <th>(v) Maximum Percentage Owned in Profit, Loss, or Capital</th>
                        <th class="addRowsColumn">
                          <i class="fa fa-plus-circle color-green" (click)="addRow('entity', 15)"></i>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (values of row.JSON_DATA; track $index; let j = $index) {
<tr class="subtableRowHeight">
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_A" maxlength="75"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_B" maxlength="10"></td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_C" maxlength="22"></td>
                        <td>
                          <select class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_D[0]">
                            @for (country of allCountries; track $index) {
<option [ngValue]="country">{{ country.label }}</option>
}
                          </select>
                        </td>
                        <td><input type="text" class="form-control input-sm" [(ngModel)]="values.DATA_ATTRIB_E" appOnlyDigits (ngModelChange)="limitDecimal(values.DATA_ATTRIB_E, '3b', j, 'DATA_ATTRIB_E')"></td>
                        <td class="addRowsColumn">
                          <i class="fa fa-minus-circle color-red" (click)="removeRow(15, j)"></i>
                        </td>
                      </tr>
}
                    </tbody>
                  </table>
                  @if (!row.JSON_DATA?.length) {
<div class="noRecordsBlock">
                    <span>No Records</span>
                  </div>
}
                </div>
}

                <!-- Conditional input fields (1f, 8, 14, 22, 25, 26/27, 29/31) -->
                @if (getConditionalInputLines().includes(row.num)) {
<input type="text" 
                       class="form-control input-sm conditional-input"
                      
                       [(ngModel)]="row.value_user_input"
                       [disabled]="row.conditionalField ?? false">
}

                <!-- PR Block - Partnership Representative -->
                @if (row.num === getPrBlockLine()) {
<div class="pr_block">
                  <span class="pr-title"><b>Designation of Partnership Representative (see instructions)
                    Enter below the information for the partnership representative (PR) for the tax year covered by this return.</b>
                  </span>
                  
                  <!-- Name of PR -->
                  <div class="row pr-row">
                    <div class="col-md-2"><span>Name of PR</span></div>
                    <div class="col-md-10">
                      <input type="text" class="form-control input-sm" 
                             [(ngModel)]="scheduleBFormView.rows[getPrNameIndex()].value"
                             [disabled]="scheduleBFormView.rows[getPrNameIndex()]?.conditionalField ?? false"
                             maxlength="75">
                    </div>
                  </div>

                  <!-- U.S. address of PR label -->
                  <div class="row pr-row">
                    <div class="col-md-12"><span>U.S. address of PR :</span></div>
                  </div>

                  <!-- PR Address Row 1: Country, Address Line 1, Address Line 2 -->
                  <div class="row pr-row">
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getPrAddressIndex(), 'attrib_mandatory_color_f')">
                        Country@if (getRowAttr(getPrAddressIndex(), 'attrib_mandatory_f')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <select class="form-control input-sm" 
                              [(ngModel)]="scheduleBFormView.rows[prAddressIdx].selected_country_id"
                              (ngModelChange)="onSelectedCountryChange(prAddressIdx)"
                              [disabled]="isRowDisabled(prAddressIdx)">
                        @for (country of allCountries; track $index) {
<option [value]="country.id">{{ country.label }}</option>
}
                      </select>
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getPrAddressIndex(), 'attrib_mandatory_color_a')">
                        Address Line 1@if (getRowAttr(getPrAddressIndex(), 'attrib_mandatory_a')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getPrAddressIndex()].attrib_value_a"
                             [disabled]="isRowDisabled(getPrAddressIndex())"
                             maxlength="35">
                    </div>
                    <div class="col-md-1"><span>Address Line 2</span></div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getPrAddressIndex()].attrib_value_b"
                             [disabled]="isRowDisabled(getPrAddressIndex())"
                             maxlength="35">
                    </div>
                  </div>

                  <!-- PR Address Row 2: City, State, Zip -->
                  <div class="row pr-row">
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getPrAddressIndex(), 'attrib_mandatory_color_c')">
                        City@if (getRowAttr(getPrAddressIndex(), 'attrib_mandatory_c')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getPrAddressIndex()].attrib_value_c"
                             [disabled]="isRowDisabled(getPrAddressIndex())"
                             maxlength="22">
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getPrAddressIndex(), 'attrib_mandatory_color_d')">
                        State@if (getRowAttr(getPrAddressIndex(), 'attrib_mandatory_d')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3" [hidden]="!isCountryUS(prAddressIdx)">
                      <select class="form-control input-sm"
                              [(ngModel)]="scheduleBFormView.rows[prAddressIdx].selected_state_id"
                              (ngModelChange)="onSelectedStateChange(prAddressIdx)"
                              [disabled]="isRowDisabled(prAddressIdx)">
                        <option value="">Select</option>
                        @for (state of allUSStates; track $index) {
<option [value]="state.id">{{ state.label }}</option>
}
                      </select>
                    </div>
                    <div class="col-md-3" [hidden]="isCountryUS(getPrAddressIndex())">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getPrAddressIndex()].attrib_value_d"
                             [disabled]="isRowDisabled(getPrAddressIndex())">
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getPrAddressIndex(), 'attrib_mandatory_color_e')">
                        Zip@if (getRowAttr(getPrAddressIndex(), 'attrib_mandatory_e')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getPrAddressIndex()].attrib_value_e"
                             [disabled]="isRowDisabled(getPrAddressIndex())"
                             appOnlyDigits>
                    </div>
                  </div>

                  <!-- U.S. phone number of PR -->
                  <div class="row pr-row">
                    <div class="col-md-2"><span>U.S. phone number of PR</span></div>
                    <div class="col-md-4">
                      <input type="text" class="form-control input-sm" appOnlyDigits
                             [(ngModel)]="scheduleBFormView.rows[getPrPhoneIndex()].value"
                             [disabled]="isRowDisabled(getPrPhoneIndex())">
                    </div>
                  </div>

                  <!-- Designated Individual Name -->
                  <div class="row pr-row">
                    <div class="col-md-4"><span>If the PR is an entity, name of the designated individual for the PR</span></div>
                    <div class="col-md-4">
                      <input type="text" class="form-control input-sm"
                             placeholder="First name"
                             aria-label="First name"
                             [ngModel]="getDesignatedIndividualFirstName()"
                             (ngModelChange)="setDesignatedIndividualFirstName($event)"
                             [disabled]="isRowDisabled(getDesignatedIndividualNameIndex())"
                             maxlength="77">
                    </div>
                    <div class="col-md-4">
                      <input type="text" class="form-control input-sm"
                             placeholder="Last name"
                             aria-label="Last name"
                             [ngModel]="getDesignatedIndividualLastName()"
                             (ngModelChange)="setDesignatedIndividualLastName($event)"
                             [disabled]="isRowDisabled(getDesignatedIndividualNameIndex())"
                             maxlength="78">
                    </div>
                  </div>

                  <!-- U.S. address of designated individual label -->
                  <div class="row pr-row">
                    <div class="col-md-12"><span>U.S. address of designated individual :</span></div>
                  </div>

                  <!-- Designated Individual Address Row 1: Country, Address Line 1, Address Line 2 -->
                  <div class="row pr-row">
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_color_f')">
                        Country@if (getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_f')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <select class="form-control input-sm" 
                              [(ngModel)]="scheduleBFormView.rows[designatedAddressIdx].selected_country_id"
                              (ngModelChange)="onSelectedCountryChange(designatedAddressIdx)"
                              [disabled]="isRowDisabled(designatedAddressIdx)">
                        @for (country of allCountries; track $index) {
<option [value]="country.id">{{ country.label }}</option>
}
                      </select>
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_color_a')">
                        Address Line 1@if (getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_a')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualAddressIndex()].attrib_value_a"
                             [disabled]="isRowDisabled(getDesignatedIndividualAddressIndex())"
                             maxlength="35">
                    </div>
                    <div class="col-md-1"><span>Address Line 2</span></div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualAddressIndex()].attrib_value_b"
                             [disabled]="isRowDisabled(getDesignatedIndividualAddressIndex())"
                             maxlength="35">
                    </div>
                  </div>

                  <!-- Designated Individual Address Row 2: City, State, Zip -->
                  <div class="row pr-row">
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_color_c')">
                        City@if (getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_c')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualAddressIndex()].attrib_value_c"
                             [disabled]="isRowDisabled(getDesignatedIndividualAddressIndex())"
                             maxlength="22">
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_color_d')">
                        State@if (getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_d')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3" [hidden]="!isCountryUS(designatedAddressIdx)">
                      <select class="form-control input-sm"
                              [(ngModel)]="scheduleBFormView.rows[designatedAddressIdx].selected_state_id"
                              (ngModelChange)="onSelectedStateChange(designatedAddressIdx)"
                              [disabled]="isRowDisabled(designatedAddressIdx)">
                        <option value="">Select</option>
                        @for (state of allUSStates; track $index) {
<option [value]="state.id">{{ state.label }}</option>
}
                      </select>
                    </div>
                    <div class="col-md-3" [hidden]="isCountryUS(getDesignatedIndividualAddressIndex())">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualAddressIndex()].attrib_value_d"
                             [disabled]="isRowDisabled(getDesignatedIndividualAddressIndex())">
                    </div>
                    <div class="col-md-1">
                      <span [class.madatoryFields]="getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_color_e')">
                        Zip@if (getRowAttr(getDesignatedIndividualAddressIndex(), 'attrib_mandatory_e')) {
<sup>*</sup>
}
                      </span>
                    </div>
                    <div class="col-md-3">
                      <input type="text" class="form-control input-sm"
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualAddressIndex()].attrib_value_e"
                             [disabled]="isRowDisabled(getDesignatedIndividualAddressIndex())"
                             appOnlyDigits>
                    </div>
                  </div>

                  <!-- U.S. phone number of designated individual -->
                  <div class="row pr-row">
                    <div class="col-md-2"><span>U.S. phone number of designated individual</span></div>
                    <div class="col-md-4">
                      <input type="text" class="form-control input-sm" appOnlyDigits
                             [(ngModel)]="scheduleBFormView.rows[getDesignatedIndividualPhoneIndex()].value"
                             [disabled]="isRowDisabled(getDesignatedIndividualPhoneIndex())">
                    </div>
                  </div>
                </div>
}

                <!-- Vote fields (By Vote / By Value) -->
                @if (row.num === getVoteLine()) {
<span class="vote-fields">
                  By Vote <input type="text" class="form-control input-sm voteFields" appOnlyDigits
                                [(ngModel)]="row.value_user_input"
                                [disabled]="row.conditionalField ?? false"
                                (ngModelChange)="onlyPercentage(row.value_user_input, row.num, i, 'value_user_input')">
                  By Value <input type="text" class="form-control input-sm voteFields" appOnlyDigits
                                 [(ngModel)]="row.value_user_input2"
                                 [disabled]="row.conditionalField ?? false"
                                 (ngModelChange)="onlyPercentage(row.value_user_input2, row.num, i, 'value_user_input2')">
                </span>
}

                <!-- Number input for specific lines -->
                @if (getNumberInputLines().includes(row.num)) {
<input type="text" class="form-control input-sm number-input" appOnlyDigits
                      
                       [(ngModel)]="row.value"
                       [disabled]="row.conditionalField ?? false">
}
              </td>

              <!-- Yes/No Checkboxes - mutual exclusive -->
              @if (isYesNoLineForYear(row.num)) {
<td class="yes-no-cell">
                <span>Yes</span>
                <input type="checkbox" 
                       [checked]="isYesChecked(row.value)"
                       (click)="onYesClick(i)">
                <span style="margin-left: 4px;">No</span>
                <input type="checkbox" 
                       [checked]="isNoChecked(row.value)"
                       (click)="onNoClick(i)">
              </td>
}
              @if (!isYesNoLineForYear(row.num)) {
<td class="yes-no-cell">&nbsp;</td>
}
            </tr>
}
          
}
        </tbody>
      </table>
    </div>
}
  </div>

  <!-- ====================== MODAL FOOTER ====================== -->
  <div class="modal-footer" [hidden]="minimise">
    <button class="save-button" type="button" (click)="onSave()" [disabled]="isSaving">
      Save and Proceed
      @if (isSaving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}
    </button>
    <button class="reset-button" type="button" (click)="onReset()">Reset</button>
    <button class="cancel-button" type="button" (click)="onCancel()">Cancel</button>
  </div>
</div>
